import { render, staticRenderFns } from "./CheckboxFormItem.vue?vue&type=template&id=43162030&"
import script from "./CheckboxFormItem.vue?vue&type=script&lang=js&"
export * from "./CheckboxFormItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxFormItem.vue?vue&type=style&index=0&id=43162030&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports